import { rowTitleGutter } from "@/components/forms/formItemsLayout";
import IdBirthdayForm from "@/components/forms/IdBirthdayForm";
import TaxRegimenForm from "@/components/forms/TaxRegimenForm";
import UploadImageForm from "@/components/forms/UploadImageForm";
import ModalMessage from "@/components/ModalMessage";
import SectionTitle from "@/components/SectionTitle";
import type { DP } from "@/hooks/usePrismic";
import { Col, Row } from "antd";

type ShowUserImageData = (_props: { key: string; val: boolean }) => void;

type BasicDataComponentProps = {
  showUserImageData: ShowUserImageData;
  registrationType: string;
  t: DP;
};

export const BasicDataComponent = ({
  showUserImageData,
  t,
  registrationType
}: BasicDataComponentProps) => {
  return (
    <>
      <Row gutter={rowTitleGutter} justify="start" align="middle">
        <Col flex={"100%"}>
          <SectionTitle
            lightText={t.constants.BASICDATA1}
            boldText={t.constants.BASICDATA2}
          />
        </Col>
      </Row>
      <TaxRegimenForm />
      {registrationType === "phoneReg" ? (
        <IdBirthdayForm showHelpMessage={true} />
      ) : (
        <UploadImageForm showUserImageData={showUserImageData} />
      )}

      <ModalMessage
        alertText={t.constants.errorProcess}
        btnText={t.constants.CERRAR}
        kind={"Error"}
      />
    </>
  );
};
